namespace $.$$ {
	$mol_style_define( $eve_app_page_components_segmented, {
	} )
}
